import FormInvitation from "../FormInvitation/FormInvitation";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroInvitation.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import InvitationService from "../../../services/InvitationService";

const CadastroInvitation = () => {
	const { invitationId } = useParams();
	const { state } = useLocation();
	const [type, setType] = useState("");
	const [invitation, setInvitation] = useState(state);

	async function loadInvitation(id) {
		const response = await InvitationService.getInvitation(id);
		if (response.data) {
			setInvitation(response.data);
		}
	}

	useEffect(() => {
		setType(invitationId || state ? "edicao" : "cadastro")

		if (invitation) {
			setInvitation(state);
			return;
		}

		if (invitationId) {
			loadInvitation(invitationId);
		}
	}, [state, invitationId]);

	return (
		<CadastroContainer>
			<FormInvitation invitation={invitation} type={type} />
		</CadastroContainer>
	);
};

export default CadastroInvitation;
